import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridDataResult, DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process, orderBy } from "@progress/kendo-data-query";
import { IMacro } from '../../../../core/models';
import { MacroService } from '../../../../core/services/macro.service';
import { UserService } from '../../../../core/services/user.service';
import { Subject } from 'rxjs';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
@Component({
  selector: 'app-manage-macro',
  templateUrl: './manage-macro.component.html',
  styleUrls: ['./manage-macro.component.scss']
})
export class ManageMacroComponent implements OnInit {

  manageMacroGridView: GridDataResult;
  macros: IMacro[] = [];
  constructor(private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private macroService: MacroService,
    private appNotifyService: AppNotifyService,
  ) {
    this.macroService.getAll().subscribe(macros => {
      this.macros = macros;
      this.loadMacroGridData();
    });

  }

  ngOnInit() {

    this.loadMacroGridData();
  }

  //#region product grid data binding
  macroLoading: boolean;
  public loadMacroGridData(): void {
    this.macroLoading = true;
    this.manageMacroGridView = process(this.macros, this.macroGridState);
    this.macroLoading = false;

  }
  //#endregion
  //#region pagination, sorting,filtering for Product grid

  public macroGridState: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'Id',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };


  public macroGridSortChange(sort): void {
    this.macroGridState.sort = sort;
    this.loadMacroGridData();
  }

  public macroGridPageChange({ skip, take }: PageChangeEvent): void {
    this.macroGridState.skip = skip;
    this.macroGridState.take;
    this.loadMacroGridData();
  }

  public macroGridDataStateChange(state: DataStateChangeEvent): void {
    this.macroGridState = state;
    this.loadMacroGridData();
  }

  //#endregion

  editMacro(dataItem: IMacro): void {
    console.log(dataItem);
    this.macroService.editmacro = dataItem;
    this.router.navigate(['./edit-macro'], { relativeTo: this.route }); // navigate to same route

  }

  //#region delete item
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();

  gridDelete = {
    label: {
      deleteConfirmLbl: 'Are you sure you want to delete Macro ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }


  public removeConfirmation(dataItem): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    return this.removeConfirmationSubject;
  }

  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.RemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
    }
  }
  public RemoveHandler() {
    this.macroService.delete(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const id = this.gridItemToRemove.id;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected Macro has been removed.");

      if (this.macros) {
        //This is a Local Remove
        const index = (this.macros).findIndex(r => r.id === id);
        (this.macros).splice(index, 1);
          this.loadMacroGridData();

        }
      
       

    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion

}
